import * as React from "react"
import { BrowserRouter as Router, Route, Switch } from "react-router-dom"
import { hot } from "react-hot-loader"
import { ThemeProvider } from "styled-components"
import * as ReactGA from "react-ga"

import theme from "./theme"
import AppErrorBoundary from "./components/app-error-boundary"

import Home from "./containers/home"

class App extends React.Component {
  componentDidMount() {
    ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_ID)
    ReactGA.pageview(window.location.pathname + window.location.search)
  }
  render() {
    return (
      <main>
        <AppErrorBoundary>
          <ThemeProvider theme={theme}>
            <Router>
              <Switch>
                <Route exact={true} path="/" component={Home} />
              </Switch>
            </Router>
          </ThemeProvider>
        </AppErrorBoundary>
      </main>
    )
  }
}

export default hot(module)(App)



// WEBPACK FOOTER //
// ./src/App.tsx